import React, { useEffect, useRef, useState } from 'react';
import { Alert, Autocomplete, Box, Button, TextField, Typography } from '@mui/material';
import { fetchCustomers } from './productpercabang/apiProductPercabang';

/**
 * Kupon & pelanggan untuk promo di dialog pembayaran kasir web.
 * - kodeTerpasang: kode kupon yang diketik kasir ('' = tidak ada); onPasang(kode) memasang / melepas ('' = lepas).
 * - kupon / galat: hasil pemeriksaan server (POST /promo/hitung): kupon = { kode, nama, potongan } bila sah, galat = alasan bila tidak.
 * - tampilPelanggan (kasir retail): pilihan pelanggan terdaftar untuk promo ulang tahun & batas per pelanggan (kasir resto sudah punya pemilih sendiri).
 */
const KuponPanel = ({ kodeTerpasang, onPasang, kupon, galat, pelanggan = null, onPelanggan, tampilPelanggan = false, disabled = false, sx }) => {
  const [ketik, setKetik] = useState('');
  const [opsi, setOpsi] = useState([]);
  const [cari, setCari] = useState('');
  const urutan = useRef(0);

  useEffect(() => {
    if (!tampilPelanggan) return undefined;
    const nomor = (urutan.current += 1);
    const t = setTimeout(async () => {
      try {
        const data = await fetchCustomers(cari);
        if (nomor === urutan.current) setOpsi(Array.isArray(data) ? data : []);
      } catch {
        if (nomor === urutan.current) setOpsi([]);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [cari, tampilPelanggan]);

  const pasang = () => {
    const kode = ketik.trim().toUpperCase();
    if (!kode) return;
    onPasang(kode);
    setKetik('');
  };

  return (
    <Box sx={sx}>
      {tampilPelanggan && (
        <Autocomplete
          size="small"
          options={opsi}
          value={pelanggan}
          disabled={disabled}
          getOptionLabel={(o) => (o ? `${o.nama}${o.telepon ? ` • ${o.telepon}` : ''}` : '')}
          isOptionEqualToValue={(a, b) => a.uuid === b.uuid}
          filterOptions={(x) => x}
          onChange={(_, v) => onPelanggan && onPelanggan(v)}
          onInputChange={(_, v, alasan) => { if (alasan === 'input') setCari(v); }}
          noOptionsText="Pelanggan tidak ditemukan"
          renderInput={(params) => <TextField {...params} label="Pelanggan terdaftar (opsional)" helperText="Untuk promo ulang tahun & batas pemakaian per pelanggan" />}
          sx={{ mb: 1.5 }}
        />
      )}
      {kodeTerpasang ? (
        <Alert
          severity={galat ? 'error' : kupon ? 'success' : 'info'}
          action={<Button color="inherit" size="small" onClick={() => onPasang('')} disabled={disabled}>Lepas</Button>}
          sx={{ alignItems: 'center' }}
        >
          <Typography variant="body2" sx={{ fontWeight: 700 }}>Kupon {kodeTerpasang}</Typography>
          <Typography variant="caption" component="div">
            {galat || (kupon ? `${kupon.nama} · potongan Rp ${Number(kupon.potongan).toLocaleString('id-ID')}` : 'Memeriksa kupon…')}
          </Typography>
        </Alert>
      ) : (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            size="small" fullWidth label="Kode kupon (opsional)" value={ketik} disabled={disabled}
            onChange={(e) => setKetik(e.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, ''))}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); pasang(); } }}
            inputProps={{ maxLength: 20 }}
          />
          <Button variant="outlined" onClick={pasang} disabled={disabled || !ketik.trim()}>Pakai</Button>
        </Box>
      )}
    </Box>
  );
};

export default KuponPanel;
